import EventEmitter from 'events';
import { parseQuery } from '@ali/re-utils';

class URI {
  static getCurrentURI() {
    const loc = window.location;
    return `${loc.origin}${loc.pathname}${loc.search}${loc.hash}`;
  }

  constructor(center, config, id) {
    this.type = 'URI';
    this.center = center;
    this.config = config || {};
    this.name = this.config.name;
    this.exports = this.config.exports;
    this.variables = null;
    this.emitter = new EventEmitter();
    this.id = id;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getConfig(key) {
    return key ? this.config[key] : this.config;
  }

  makeVariables() {
    if (!this.exports || !Array.isArray(this.exports) || this.exports.length < 1) {
      this.variables = this.data || {};
      return;
    }
    this.variables = {};
    if (!this.data) return;

    this.exports.forEach((item) => {
      if (this.data[item.field] != null) {
        this.variables[item.name] = this.data[item.field];
      } else {
        this.variables[item.name] = item.defaultValue || '';
      }
    });
  }

  execute() {
    const uri = URI.getCurrentURI();
    const m = /(?:\?([^#]*))?(?:#(.*))?$/.exec(uri);
    if (m) {
      if (m[1]) {
        this.data = parseQuery(m[1]);
      }
      if (m[2]) {
        const hashMatch = /(?:\?([^#]*))/.exec(m[2]);
        if (hashMatch && hashMatch[1]) {
          this.data = {
            ...this.data,
            ...parseQuery(hashMatch[1]),
          };
        }
      }
    }
    this.makeVariables();

    return Promise.resolve(this.getVariables());
  }

  getVariables() {
    return this.variables;
  }


  onChange(func) {
    this.emitter.on('change', func);
    return () => {
      this.emitter.removeListener('change', func);
    };
  }
}

export default URI;
